
export default {
  data: function () {
    return {
      visible: false,
    };
  },

  mounted: function () {
    window.addEventListener('scroll', this.eventScroll);
  },

  methods: {
    eventScroll: function () {
      this.visible = Boolean(window.scrollY > 200);
    },
    scrollTop: function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
